import React, {useCallback, useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from '../../store';
import {useTranslation} from 'react-i18next';
import {PaginationMode} from '../../components/DataGrid/types';
import DataGrid from '../../components/DataGrid/DataGrid';
import {generateColumns, useStyles} from './CompanyPhoneBookList.utils';
import {ReduxState} from '../../store/types';
import { PeersContactListItem } from '../../store/actions/accountDashboard/payloads';

export type CompanyPhoneBookListProps = {
}

export const CompanyPhoneBookList: React.VFC<CompanyPhoneBookListProps> = ({
    }) => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {peerContacts, isLoadingPeerContacts} = useSelector(
        (state: ReduxState) => state.accountDashboard,
    );
    
    const fetchData = useCallback(() => {
        dispatch(actions.getAccountDashboardPeersContactList.request());
    }, []);

    useEffect(() => {
        if(peerContacts === undefined)
        {
            fetchData();
        }
    }, [peerContacts])

    const columns = useMemo(() => {
        return generateColumns(
            t,
            classes,
        );
    }, []);

    return (
        <>
            <DataGrid<PeersContactListItem>
                columns={columns}
                data={peerContacts ?? []}
                rowCount={peerContacts?.length ?? 0}
                loading={isLoadingPeerContacts}
                paginationMode={PaginationMode.Client}
                centeredRows
                narrowRows
                initialPageSize={10}
                classes={{
                    tableContainer: classes.tableContainer,
                }}
                getItemId={(item) => item.i_account}
            />
        </>
    );
};
